import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  InputAdornment, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TextField, Typography, useMediaQuery, useTheme,
} from "@material-ui/core";
import { AddAlarmOutlined, ArrowBack, AssignmentTurnedInOutlined, Clear, ConfirmationNumberOutlined, DeleteOutline, InfoOutlined, Input, Refresh, Search } from "@material-ui/icons";
import { Alert, Pagination, Skeleton } from "@material-ui/lab";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import axios from "services/auth/jwt/config";
import { statuses, errorText } from "./utils";
import useStyles from "@jumbo/Dashboards/FormBuilder/recordListStyles";
import TicketListItem from "./TicketListItem";

function TicketManager({ id }) {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [form, setForm] = useState(null);
  const [result, setResult] = useState({ docs: [], totalPages: 0, totalDocs: 0 });
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("");
  const [searchDraft, setSearchDraft] = useState("");
  const [search, setSearch] = useState("");
  const [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submittedResponse, setSubmittedResponse] = useState(null);
  const [action, setAction] = useState(null);
  const [minutes, setMinutes] = useState("10");
  const [saving, setSaving] = useState(false);
  const [actionError, setActionError] = useState("");
  const [menu, setMenu] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    axios.get(`/formticket/admin/${id}`, { params: { page, limit: 10, status, searchString: search } })
      .then(({ data }) => {
        if (!active) return;
        setForm(data.form);
        setResult(data);
        if (page > Math.max(1, data.totalPages)) setPage(Math.max(1, data.totalPages));
      })
      .catch(err => { if (active) setError(errorText(err)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id, page, status, search, revision]);

  const openAction = (type, ticket) => {
    setMenu(null);
    setSuccess("");
    setSubmittedResponse(null);
    setActionError("");
    setMinutes("10");
    setAction({ type, ticket });
  };
  const closeAction = () => { if (!saving) setAction(null); };
  const save = async event => {
    event.preventDefault();
    const extension = Number(minutes);
    if (action.type === "extend" && (!Number.isInteger(extension) || extension < 1 || extension > 1440)) {
      setActionError("زمان اضافه باید عدد صحیح بین ۱ تا ۱۴۴۰ دقیقه باشد");
      return;
    }
    setSaving(true);
    setActionError("");
    try {
      const url = `/formticket/admin/${id}/${action.ticket._id}`;
      if (action.type === "extend") await axios.patch(`${url}/extend`, { minutes: extension });
      else if (action.type === "submit") {
        const { data } = await axios.post(`${url}/submit`);
        setSubmittedResponse(data.formFilled._id);
      }
      else await axios.delete(url);
      setSuccess(action.type === "submit" ? "ورودی آزمون با موفقیت ثبت شد" : action.type === "extend" ? "زمان بلیط با موفقیت تمدید شد" : "بلیط با موفقیت حذف شد");
      setAction(null);
      setRevision(value => value + 1);
    } catch (err) { setActionError(errorText(err)); }
    finally { setSaving(false); }
  };
  const inputsUrl = `/forminputs/${id}?name=${encodeURIComponent(form?.title || "")}`;
  const ownerName = ticket => form?.privacyMode ? "شرکت‌کننده" : ticket.owner?.fullName || "کاربر حذف شده";
  const hasFilters = Boolean(search || status);
  const clearFilters = () => { setSearchDraft(""); setSearch(""); setStatus(""); setPage(1); };
  const firstRecord = result.docs.length ? (page - 1) * 10 + 1 : 0;
  const lastRecord = (page - 1) * 10 + result.docs.length;

  return <PageContainer heading="مدیریت بلیط‌های آزمون" breadcrumbs={[
    { label: "فرم‌ها", link: "/forms" },
    { label: "بلیط‌های آزمون", isActive: true },
  ]}>
    <Box className={classes.hero}>
      <Box className={classes.heroIdentity}>
        <Box className={classes.heroIcon}><ConfirmationNumberOutlined /></Box>
        <Box>
          <Typography className={classes.eyebrow}>پیگیری پاسخ‌ها و مدیریت زمان آزمون</Typography>
          <Typography component="h2" className={classes.heroTitle}>{form?.title || "بلیط‌های آزمون"}</Typography>
        </Box>
      </Box>
      <Box className={classes.heroActions}>
        <Button component={Link} to="/forms" startIcon={<ArrowBack />} className={classes.button}>بازگشت به فرم‌ها</Button>
        <Button component={Link} to={inputsUrl} variant="outlined" color="primary" startIcon={<Input />} className={classes.button}>ورودی‌های فرم</Button>
        <Button disabled={loading || saving} startIcon={<Refresh />} className={classes.button} onClick={() => setRevision(value => value + 1)}>بارگذاری مجدد</Button>
      </Box>
    </Box>
    <Paper elevation={0} className={classes.panel}>
      <Box className={classes.panelHeader}>
        <Typography component="h3" className={classes.panelTitle}>شرکت‌کنندگان آزمون</Typography>
        {!loading && !error && <Box component="span" className={classes.count} px={1.5} py={0.5} borderRadius={8} fontSize={12}>
          {result.totalDocs.toLocaleString("fa-IR")} {hasFilters ? "نتیجه" : "بلیط"}
        </Box>}
      </Box>
        <Box component="form" onSubmit={event => { event.preventDefault(); setPage(1); setSearch(searchDraft.trim()); }}
          className={classes.filters}>
          <TextField id="form-ticket-search" label="جستجوی شرکت‌کننده" placeholder="نام، کد پرسنلی، کد ملی یا تلفن" variant="outlined" size="small"
            value={searchDraft} onChange={event => setSearchDraft(event.target.value)}
            inputProps={{ maxLength: 200 }} className={classes.search}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search className={classes.searchIcon} /></InputAdornment> }} />
          <TextField select id="form-ticket-status" label="وضعیت بلیط" value={status} disabled={saving} variant="outlined" size="small"
            onChange={event => { setPage(1); setStatus(event.target.value); }} className={classes.statusFilter}>
            <MenuItem value="">همه</MenuItem>
            {Object.entries(statuses).map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
          </TextField>
          <Button type="submit" variant="contained" color="primary" disabled={loading || saving} startIcon={<Search />} className={classes.button}>جستجو</Button>
          {hasFilters && <Button disabled={loading || saving} startIcon={<Clear />} className={classes.button} onClick={clearFilters}>پاک کردن فیلترها</Button>}
        </Box>
        {success && <Alert severity="success" className={classes.alert} onClose={() => { setSuccess(""); setSubmittedResponse(null); }}>{success}
          {submittedResponse && <Button component={Link} to={`/formFillDetails/${submittedResponse}`} color="primary" size="small">نمایش ورودی ثبت‌شده</Button>}
        </Alert>}
        {error && <Alert severity="error" className={classes.alert}>{error}</Alert>}
        {loading ? <Box className={classes.loading}>
          <Typography role="status" color="textSecondary">در حال دریافت بلیط‌ها…</Typography>
          {[1, 2, 3].map(value => <Skeleton key={value} variant="rect" height={64} aria-hidden="true" />)}
        </Box> : !error && <>
          {!result.docs.length ? <Box className={classes.empty}>
            <Search />
            <Typography className={classes.emptyTitle}>بلیطی یافت نشد</Typography>
            <Typography color="textSecondary" variant="body2">{hasFilters ? "فیلترها را تغییر دهید یا جستجوی دیگری انجام دهید." : "با شروع آزمون توسط کاربران، بلیط‌ها در این بخش نمایش داده می‌شوند."}</Typography>
          </Box> : mobile ? <Box className={classes.mobileList}>
            {result.docs.map(ticket => <TicketListItem key={ticket._id} ticket={ticket} formId={id} inputsUrl={inputsUrl}
              privacyMode={form?.privacyMode} name={ownerName(ticket)} saving={saving} mobile onMenu={(event, target) => setMenu({ anchor: event.currentTarget, ticket: target })} />)}
          </Box> : <TableContainer>
            <Table aria-label="بلیط‌های آزمون" className={classes.table}>
              <TableHead><TableRow>
                {["شرکت‌کننده", "اطلاعات تماس", "وضعیت", "پیشرفت پاسخگویی", "زمان آزمون", "عملیات"].map(label =>
                  <TableCell key={label}>{label}</TableCell>)}
              </TableRow></TableHead>
              <TableBody>
                {result.docs.map(ticket => <TicketListItem key={ticket._id} ticket={ticket} formId={id} inputsUrl={inputsUrl}
                  privacyMode={form?.privacyMode} name={ownerName(ticket)} saving={saving} onMenu={(event, target) => setMenu({ anchor: event.currentTarget, ticket: target })} />)}
              </TableBody>
            </Table>
          </TableContainer>}
          {result.totalDocs > 0 && <Box className={classes.footer}>
            <Typography variant="caption" color="textSecondary">نمایش {firstRecord.toLocaleString("fa-IR")}–{lastRecord.toLocaleString("fa-IR")} از {result.totalDocs.toLocaleString("fa-IR")} بلیط</Typography>
            {result.totalPages > 1 && <Pagination count={result.totalPages} page={page} color="primary" shape="rounded" disabled={saving} onChange={(_, value) => setPage(value)} />}
          </Box>}
        </>}
    </Paper>
    <Box className={classes.help}><InfoOutlined /><Typography>تمدید زمان، پاسخ‌ها و سوالات ذخیره‌شده را حفظ می‌کند. پاسخ نهایی بلیط‌های ثبت‌شده از بخش ورودی‌های فرم در دسترس است.</Typography></Box>
    <Menu anchorEl={menu?.anchor} open={Boolean(menu)} onClose={() => setMenu(null)}
      getContentAnchorEl={null} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
      classes={{ paper: classes.menuPaper }}>
      {menu && <MenuItem className={classes.menuItem} onClick={() => openAction("submit", menu.ticket)}><AssignmentTurnedInOutlined color="primary" />ثبت ورودی</MenuItem>}
      {menu?.ticket.durationEnabled && <MenuItem className={classes.menuItem} onClick={() => openAction("extend", menu.ticket)}><AddAlarmOutlined />تمدید زمان</MenuItem>}
      {menu && <MenuItem className={`${classes.menuItem} ${classes.deleteAction}`} onClick={() => openAction("delete", menu.ticket)}><DeleteOutline />حذف بلیط</MenuItem>}
    </Menu>
    <Dialog open={Boolean(action)} onClose={closeAction} fullWidth maxWidth="sm"
      aria-labelledby="form-ticket-action-title" PaperProps={{ component: "form", onSubmit: save, className: classes.dialogPaper }}>
      {action && <>
        <DialogTitle id="form-ticket-action-title" className={classes.dialogTitle}>{action.type === "submit" ? "ثبت ورودی آزمون" : action.type === "extend" ? "تمدید زمان بلیط" : "حذف بلیط آزمون"}</DialogTitle>
        <DialogContent>
          <Box className={classes.dialogParticipant}>
            <Avatar className={classes.avatar}>{ownerName(action.ticket).trim().charAt(0)}</Avatar>
            <Box><Typography className={classes.participantName}>{ownerName(action.ticket)}</Typography>
              <Typography className={classes.secondary}>کد پرسنلی: {action.ticket.owner?.personnelCode || "—"}</Typography></Box>
          </Box>
          {action.type === "extend" ? <>
            <Typography className={classes.dialogDescription}>زمان اضافه به مهلت فعلی افزوده می‌شود. برای بلیط منقضی‌شده، زمان اضافه از لحظه تمدید محاسبه می‌شود و امکان ادامه آزمون فراهم می‌شود.</Typography>
            <TextField autoFocus fullWidth required id="form-ticket-extension" label="زمان اضافه (دقیقه)" type="number" variant="outlined"
              value={minutes} disabled={saving} onChange={event => setMinutes(event.target.value)} inputProps={{ min: 1, max: 1440, step: 1 }} />
            <Box className={classes.durationPresets}>{[5, 10, 15, 30].map(value => <Button key={value} size="small" disabled={saving}
              color={Number(minutes) === value ? "primary" : "default"} variant="outlined" className={classes.button} onClick={() => setMinutes(String(value))}>{value.toLocaleString("fa-IR")} دقیقه</Button>)}</Box>
          </> : action.type === "submit" ? <Alert severity="info">
            آخرین پاسخ‌های ذخیره‌شده این بلیط به‌عنوان ورودی فرم ثبت و آزمون برای این کاربر نهایی می‌شود. سوال‌های بدون پاسخ، خالی ثبت می‌شوند و امکان ادامه پاسخگویی وجود نخواهد داشت. آیا اطمینان دارید؟
          </Alert> : <Alert severity="warning">
            با حذف بلیط، سوالات انتخاب‌شده و پاسخ‌های ذخیره‌شده آن حذف می‌شوند. کاربر در مراجعه بعدی می‌تواند آزمون را با یک بلیط جدید شروع کند. آیا اطمینان دارید؟
          </Alert>}
          {actionError && <Typography color="error" role="alert">{actionError}</Typography>}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button disabled={saving} onClick={closeAction} className={classes.button}>انصراف</Button>
          <Button disabled={saving} type="submit" variant="contained" color={action.type === "delete" ? "secondary" : "primary"} className={classes.button}>
            {saving ? "در حال ذخیره…" : action.type === "submit" ? "تایید ثبت ورودی" : action.type === "extend" ? "تایید تمدید" : "تایید حذف"}
          </Button>
        </DialogActions>
      </>}
    </Dialog>
  </PageContainer>;
}

export default function FormTickets() {
  const { id } = useParams();
  return <TicketManager key={id} id={id} />;
}
